import {useTypeGuards} from './useTypeGuards';
import type {UserInfo} from '../types/custom';

const {hasProperty} = useTypeGuards();

const isUserInfo = (userInfo: unknown): userInfo is UserInfo => {
    if (userInfo === undefined || userInfo === null) {
        return false;
    }
    return (
        hasProperty(userInfo, 'firstName') &&
        hasProperty(userInfo, 'lastName') &&
        hasProperty(userInfo, 'profileId') &&
        hasProperty(userInfo, 'unread') &&
        hasProperty(userInfo, 'unreadByIdentity') &&
        hasProperty(userInfo, 'connected') &&
        hasProperty(userInfo, 'photo') &&
        hasProperty(userInfo, 'enable') &&
        hasProperty(userInfo, 'likelyAnAdmin') &&
        hasProperty(userInfo, 'identities')
    );
};

const isCompany = (userInfo?: UserInfo | null) => {
    // if we do not have identity, we will consider that the user is a freelance
    return userInfo?.identities?.find((identity) => identity?.selected)?.type === 'Client';
};

export const useUserInfoHelpers = () => {
    return {
        isUserInfo,
        isCompany,
    };
};
